import {
  DISCOUNT_EXPERIMENT_FR,
  EXPERIMENT_VARIATION,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { type SearchHit } from 'types/search'
import { type Experiment } from 'types/shopConfig'

type Prices = {
  type: 'list' | 'retail'
  amount: number
  currency: string
}[]

export const removeDiscountIfNeeded = ({ prices }: { prices: Prices }) => {
  const listPrice = prices.find(p => p.type === 'list')
  const retailPrice = prices.find(p => p.type === 'retail')
  // use the retail price as list price
  if (listPrice && retailPrice && retailPrice.amount > 0) {
    return [{ ...retailPrice, type: 'list' }, retailPrice]
  }
  if (listPrice) {
    return [listPrice]
  }

  return prices
}

export const EXCLUDED_PRODUCT_CUSTOM_USECASE = 'cro_4200'

type DiscountExperimentIsCategoryCodeWhitelistedProps = {
  custom_usecases?: string[]
  experiments: Experiment[]
}
export const discountExperimentIsCategoryCodeWhitelisted = ({
  custom_usecases,
  experiments,
}: DiscountExperimentIsCategoryCodeWhitelistedProps) => {
  const experiment = getExperiment(DISCOUNT_EXPERIMENT_FR, experiments)

  if (!experiment.isEnabled || experiment.variant !== EXPERIMENT_VARIATION.V1) {
    return true
  }

  return (
    experiment.variant === EXPERIMENT_VARIATION.V1 &&
    custom_usecases?.includes(EXCLUDED_PRODUCT_CUSTOM_USECASE)
  )
}

export const discountExperimentRemoveAllDiscountsFromAlgoliaHits = ({
  hits,
  experiments,
}: {
  hits: SearchHit[]
  experiments: Experiment[]
}) => {
  return hits?.map(hit => {
    const isProductExcluded = discountExperimentIsCategoryCodeWhitelisted({
      custom_usecases: hit.custom_usecases,
      experiments,
    })

    if (isProductExcluded) {
      return {
        ...hit,
      }
    }

    const defaultPrices = hit.prices as Prices

    const prices = removeDiscountIfNeeded({ prices: defaultPrices })

    return {
      ...hit,
      best_offer: hit.best_offer
        ? {
            ...hit.best_offer,
            discount: 0,
            strike_price: null,
          }
        : undefined,
      prices,
      discount: 0,
      discountPercent: hit.discountPercent ? 0 : undefined,
      discountInPercent: hit.discountInPercent ? 0 : undefined,
      listPriceFormatted: hit.listPriceFormatted ? 0 : undefined,
      variants: hit.variants?.map(variant => {
        return {
          ...variant,
          hide_discounts: true,
          discount: 0,
          best_offer: variant?.best_offer ?? {
            ...variant?.best_offer,
            discount: 0,
            strike_price: null,
          },
          prices: removeDiscountIfNeeded({ prices: variant.prices }),
        }
      }),
    }
  })
}
